import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import Text from '../../atoms/Text';
import { ReactComponent as EyeIcon } from './images/eye.svg';
import eye from '../../assets/images/eye.svg';
import './styles.scss';
import Image from '../../atoms/Image';
interface IStatsShortProps {
  buyCount: number;
  sellCount: number;
  onShowModal: () => void;
}

const StatsShort = (props: IStatsShortProps) => {
  useEffect(() => {
    setTimeout(ReactTooltip.rebuild, 0);
  }, []);

  const { buyCount, sellCount, onShowModal } = props;

  return (
    <div className='stats_column'>
      <Text size={12} className='info text--grey-600 text--weight-500'>
        {buyCount + sellCount}
      </Text>
      <Image
        className='stats_column__eye'
        onClick={onShowModal}
        data-tip='Show detailed info'
        data-effect='solid'
        src={eye}
        size='s'
      />
    </div>
  );
};

export default StatsShort;
